import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .directive('pkpTsoAssignmentCheck', pkpTsoAssignmentCheck);

    /**
     * @author frbomke.btc
     * @ngInject
     */
    function pkpTsoAssignmentCheck() {
        return {
            restrict: 'E',
            scope: {
                showapproved: '=',
                tsoconfig: '=',
                networkpoint: '='
            },
            template:
                require('app/_directives/pkp-tso-assignment-check.directive.html')
        };
    }
})();
